import { Injectable, Inject, ApplicationRef, Component, ErrorHandler, NgZone, OnDestroy } from '@angular/core';
import { SwUpdate, SwPush } from '@angular/service-worker';
import { concat, interval, Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import { MatSnackBar, MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { IdbPowerPortalService } from './idb_PowerPortal/idb-power-portal.service';
import { Globals } from 'src/app/globals';
import { User } from './userStore/user.model';
//import { WINDOW } from '@ng-toolkit/universal';

@Injectable()
export class ApplicationStateService {

  private isMobileResolution: boolean;
  //public screenWidth: string;
  public screenInnerWidth: any;

  constructor(
   // @Inject(WINDOW) private window: Window,
  ) {

    if (window.innerWidth < 768) {
      this.isMobileResolution = true;
    } else {
      this.isMobileResolution = false;
    }

    this.screenInnerWidth = window.innerWidth;

   // this.checkWidth();

  }

  public getIsMobileResolution(): boolean {
    return this.isMobileResolution;
  }

  //onMobileChange(status: boolean) {
   // this.isMobile.next(status);
  //}

  /*
  public checkWidth() {
    var width = window.innerWidth;
    if (width <= 768) {
      this.screenWidth = 'sm';
      this.onMobileChange(true);
    } else if (width > 768 && width <= 992) {
      this.screenWidth = 'md';
      this.onMobileChange(false);
    } else {
      this.screenWidth = 'lg';
      this.onMobileChange(false);
    }
  }
  */

}

@Injectable()
export class UpdateServiceWorker implements OnDestroy {

  durationInSeconds = 30; //20;
  ngUnsubscribe = new Subject<void>();
  constructor(
    public updates: SwUpdate,
    private swPush: SwPush,
    private _snackBar: MatSnackBar,
    private webWorker_PowerPortal: IdbPowerPortalService,
    public globals: Globals,
    private ngZone: NgZone,
  ) {

    if (updates.isEnabled) {
      interval(6 * 60 * 60).subscribe(() => updates.checkForUpdate()
        .then(() => console.log('checking for updates')));
    }

    /*
    snackBarRef.afterDismissed().subscribe(info => {
      if (info.dismissedByAction === true) {
        // your code for handling this goes here
      }
    });
    */

  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public checkForUpdates(): void {
    console.log("Checking for service worker updates");

    
    //For Testing
    /*
    this.openSnackBar("A new version of the Power Portal is available", "Update", () => {
      console.log("Test");
      //document.location.reload()
    })
    */
    
    this.updates.available.subscribe((event) => {

      var appData = {
        activeVersion: "",
        updateRequired: false,
        currentVersion: "",
        message: "",
      }
      this.webWorker_PowerPortal.appVersionUpdateCheck(appData);

      this.promptUser()
    });
  }

  openSnackBar(message, action, callBack) {
    var data = {
      message: message,
      action: action,
    }
    this._snackBar.openFromComponent(UpdateServiceWorkerSnackBar, {
      data: data,
      duration: this.durationInSeconds * 1000,
    });
  }

  private promptUser(): void {
    this.updates.activateUpdate().then(() => {
      this.openSnackBar("A new version is available", "Update", () => {
        //this.openSnackBar("A new version of the Power Portal is available", "Update", () => {

        var appData = {
          activeVersion: "",
          updateRequired: false,
          currentVersion: "",
          message: "",
        }
        this.webWorker_PowerPortal.appVersionUpdateCheck(appData);

        var today = new Date();
        var dataObj = { itemName: "serviceWorkerDateUpdated", value: today };
        this.webWorker_PowerPortal.updateItem(dataObj, (results) => { });  
      })   
    });
  }

  //Public Key: BIAVpzGgkDDNHLI_3rsg0SpRy2DpKhyjZq35HTKXHWHsDzqKNpGfgVhyLx9AloCNGsvLt3lgl0985xgcAfOLykQ
  //Private Key: 4pPEMC9F9zjKj4ZxYySVtttloRBQA3eoB27AvCGEz28

  //HANDLE PUSH NOTIFICATIONS
  readonly VAPID_PUBLIC_KEY = 'BIAVpzGgkDDNHLI_3rsg0SpRy2DpKhyjZq35HTKXHWHsDzqKNpGfgVhyLx9AloCNGsvLt3lgl0985xgcAfOLykQ'; // from your backend

  // 🔔 Request permission and subscribe user to push notifications
  public subscribeToNotifications(user: User, notifyDenied: boolean = false): void {
    //console.log("Test Notifications");
    if (!this.swPush.isEnabled) {
      console.warn('Push notifications are not enabled or supported in this browser.');
      return;
    }

    //this.ensureSubscription();

    this.swPush.requestSubscription({
      serverPublicKey: this.VAPID_PUBLIC_KEY
    })
      .then(subscription => {
        console.log('User subscribed to push notifications:', JSON.stringify(subscription));
        // 👉 Send subscription to your backend
        const endPoint = subscription.endpoint || "";

        var postData = [
          {
            dataRequest: "register_push_notifications", //"addUserAccess"         
            //username: user.username,
            employeeName: user.name,
            employeeEmail: user.email,
            employeeNumber: user.employeeNumber,
            moduleData: "W10=", //JARED
            subscription: JSON.stringify(subscription),
            endPoint: endPoint,
            overrideError: 0,
            id: 0,
            requestType: "register",
          }
        ];

        this.webWorker_PowerPortal.updatePushNotifications(postData).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any[]) => {
          console.log("res: " + JSON.stringify(res));
        }, (error) => {
          console.log("error: " + JSON.stringify(error));
        }, () => {
          console.log("api complete");
        });

        //this.webWorker_PowerPortal.getItem("notificationPermissions"
        var notificationPermissions = { permission: 'granted', lastAsked: new Date()}
        this.webWorker_PowerPortal.updateItem({ itemName: "notificationPermissions", value: structuredClone(notificationPermissions) }, (results) => { });

        //TESTING        
        if (user.email.toLowerCase() === "jared.stevens@qualuscorp.com") {
          //alert("User subscribed to push notifications!")
        }
             
      })
      .catch(async err => {
        console.error('Failed to subscribe user:', err);
        /*
        if (user.email.toLowerCase() === "jared.stevens@qualuscorp.com") {
          alert("Failed to subscribe user: " + err)
        }
        */
        const reg = await navigator.serviceWorker.ready;
        const oldSub = await reg.pushManager.getSubscription();
        if (oldSub) await oldSub.unsubscribe();

        const newSub = await this.swPush.requestSubscription({
          serverPublicKey: this.VAPID_PUBLIC_KEY
        }).then(subscription => {


          if (user.email.toLowerCase() === "jared.stevens@qualuscorp.com") {
              console.log('User subscribed to push notifications (RESUBSCRIBED):', JSON.stringify(subscription));
              //SEND TO BACK END - API

              const endPoint = subscription.endpoint || "";

              var postData = [
                {
                  dataRequest: "register_push_notifications", //"addUserAccess"         
                  //username: user.username,
                  employeeName: user.name,
                  employeeEmail: user.email,
                  employeeNumber: user.employeeNumber,
                  moduleData: "W10=", //JARED
                  subscription: JSON.stringify(subscription),
                  endPoint: endPoint,
                  overrideError: 0,
                  id: 0,
                  requestType: "register",
                }
              ];

              this.webWorker_PowerPortal.updatePushNotifications(postData).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any[]) => {
                console.log("res: " + JSON.stringify(res));
              }, (error) => {
                console.log("error: " + JSON.stringify(error));
              }, () => {
                console.log("api complete");
              });

              var notificationPermissions = { permission: 'granted', lastAsked: new Date() }
              this.webWorker_PowerPortal.updateItem({ itemName: "notificationPermissions", value: structuredClone(notificationPermissions) }, (results) => { });
          }

        }).catch(err => {

          console.error('Failed to subscribe user:', err);
          if (notifyDenied) {
            if (typeof err.message && err.message.toLowerCase().includes('permission denied')) {
              var notifyAlert = "Notifications have been disabled on your device"
              if (navigator.userAgent.includes('Safari')) {
                notifyAlert = 'To Allow Notifications: Go to Settings → Notifications → Allow notifications for this site.'
              } else {
                notifyAlert = 'To Allow Notifications: Go to Settings → Privacy → Manage Privacy settings → Notifications → Set To "Allowed"'
              }
              this.webWorker_PowerPortal.showAlertBar(notifyAlert, "error", "right", "top");
            }
          }
        });
        if (newSub !== undefined) {
          console.log('✅ Recovered subscription:', newSub);
        }

      });
  }


  public checkNotificationPermissions(user: User, nextAttemptDays: number = 4, requestNow: boolean = false) {
    const permission = Notification.permission;
    console.log("notification permissions: " + Notification.permission);
    if (permission === 'granted') {
      // User already allowed notifications
      // No need to ask or check IndexedDB
      console.log("Notification Permission Granted: no need to ask again")
      return;
    }

    if (permission === 'denied') {
      // User blocked notifications in browser
      // Can check IndexedDB to see when you last prompted

      this.webWorker_PowerPortal.getItem("notificationPermissions", (results) => {
        if (results.value) {
          //takeTheTour();

          var permObject: any = results.value;
          if (permObject.lastAsked && permObject.permission !== "granted") {
            const lastAsked = new Date(permObject.lastAsked);
            const daysSince = (new Date().getTime() - lastAsked.getTime()) / (1000 * 60 * 60 * 24);
            if (daysSince >= nextAttemptDays) {
              // Time to ask again
              this.subscribeToNotifications(user);
            }
          }
          if (permObject.lastAsked && permObject.permission === "granted") {
            //SHOW 'UPDATE PRIVACY MESSAGE'
            //this.ngZone.run(() => {
            var notifyAlert = "Notifications have been disabled on your device"
            if (navigator.userAgent.includes('Safari')) {
              notifyAlert = 'Go to Settings → Notifications → Allow notifications for this site.'
            } else {
              notifyAlert = 'Go to Settings → Privacy and security → Site settings → Notifications.'
            }
            this.webWorker_PowerPortal.showAlertBar(notifyAlert, "Ok", "right", "top");

            //})
          }
        }
      });

    }

    if (permission === 'default') {
      // User has never been asked
      // Check IndexedDB to see if you recently asked (cooldown)
      this.subscribeToNotifications(user);
    }
  }

  /*
  // 📩 Handle incoming push notification messages
  public listenToMessages(): void {
    this.swPush.messages.subscribe((message: any) => {
      console.log('Received push message:', message);

      //const title = message?.title || 'Qualus Notification';
      //const body = message?.message || 'You have a new notification.';
      //const url = message?.url || 'https://portal.qualus.com';
      //this.ngZone.run(() => {
        const title = message?.title || 'Notification';
        const body = message?.message || message?.body ||'You have a new notification.';
        const relativeUrl = message?.url || '/';
        const rootUrl = window.location.origin; // e.g. https://localhost:4200 or your deployed domain
        const fullUrl = new URL(relativeUrl, rootUrl).toString(); // safely join root + relative

        // Show a system notification
        if (Notification.permission === 'granted') {

          const notification = new Notification(title, {
            body: body,
            icon: '/assets/icons/Qualus_Q_512.png',
            data: {
              fullUrl
            }
          });

          console.log("Notification: " + JSON.stringify(notification))

          //UPDATE GLOBAL NOTIFICATIONS
          var notificationArray = [...this.webWorker_PowerPortal.notificationsData];
          notificationArray.push(notification);
          this.webWorker_PowerPortal.update_notifications_data(notificationArray)

          // Open the URL when the user clicks the notification
          notification.onclick = (event) => {
            event.preventDefault();
            window.open(fullUrl, '_blank');
          };

          //private _count = new BehaviorSubject<number>(0);
          if ('setAppBadge' in navigator) {
            // @ts-ignore
            navigator.setAppBadge(notificationArray.length || 0);    
          }


        } else {
          console.warn('🚫 Notification permission not granted');
        }
     // });
    });
  }

  // ⚠️ Handle push notification errors
  public listenToErrors(): void {
    this.swPush.notificationClicks.subscribe(({ action, notification }) => {
      console.log('Notification clicked:', notification);
    });
  }
  */

  async ensureSubscription() {
    if (!('serviceWorker' in navigator)) return;

    try {
      const reg = await navigator.serviceWorker.ready;
      const existing = await reg.pushManager.getSubscription();

      if (existing) {
        // Test whether it’s still valid
        const isValid = await this.verifyWithBackend(existing);
        if (isValid) {
          console.log('✅ Existing subscription is valid');
          return existing;
        }
        console.log('⚠️ Old subscription invalid, unsubscribing...');
        await existing.unsubscribe();
      }

      console.log('🔄 Creating new subscription...');
      const newSub = await this.swPush.requestSubscription({
        serverPublicKey: this.VAPID_PUBLIC_KEY,
      });

      //await this.sendToBackend(newSub);
      console.log('✅ New subscription saved');
      return newSub;

    } catch (err) {
      console.error('❌ Failed to ensure subscription', err);
      return null;
    }
  }

  /** Optional: tell your backend to check if subscription still valid */
  private verifyWithBackend(sub: PushSubscription): Promise<boolean> {
    // You could POST to an endpoint that pings the push service.
    // For now, just return true.
    return Promise.resolve(true);
  }

  
  /** Send new subscription to your API */
  /*
  private async sendToBackend(sub: PushSubscription) {
    await this.http
      .post(this.backendUrl, sub)
      .toPromise()
      .catch(err => console.error('Failed to send subscription to backend', err));
  }
  */



}


@Injectable()
export class CheckForUpdateService {

  constructor(appRef: ApplicationRef, updates: SwUpdate) {
    // Allow the app to stabilize first, before starting polling for updates with `interval()`.
    const appIsStable$ = appRef.isStable.pipe(first(isStable => isStable === true));
    const everySixHours$ = interval(6 * 60 * 60 * 1000);
    const everySixHoursOnceAppIsStable$ = concat(appIsStable$, everySixHours$);

    everySixHoursOnceAppIsStable$.subscribe(() => updates.checkForUpdate());
  }
}


@Injectable()
export class PromptUpdateService {

  constructor(updates: SwUpdate) {
    updates.available.subscribe(event => {
      /*
      if (promptUser(event)) {
        updates.activateUpdate().then(() => document.location.reload());
      }
      */
    });
  }
}


@Injectable()
export class AppEventMessagesService {

  constructor() {
           
  }

  //LISTEN FOR NETWORK SYNC MESSAGE  
  initEventMessagesListener() {
    if (navigator.serviceWorker) {
      console.log("Trying to listen to messages, found service worker...")
      navigator.serviceWorker.addEventListener('message', event => {
        this.update_event_messages_data(event);
      });
    } else {
      console.log("unable to listen to messages, service worker not found")
    }   
  }

  //REGISTER EVENT IF OFFLINE MODE IS USED
  registerNetworkSync(): void {
    navigator.serviceWorker.ready.then(reg => {
      const swReg: any = reg;
      if ('sync' in swReg) {
        swReg.sync.register('notify-app-online')
          .then(() => console.log('Background sync registered'))
          .catch(err => console.error('Failed to register sync', err));
      } else {
        console.warn('Background Sync not supported — using fallback');
        //this.handleNetworkRestoredManually();
      }
    });
  }

  //notificationsData = [];
  public event_messages_data = new Subject<any>();
  get get_event_messages_data() {
    return this.event_messages_data.asObservable();
  }
  public update_event_messages_data(data) {
    //this.notificationsData = notificationsData
    this.event_messages_data.next(data)
  }
}






@Component({
  selector: 'update-service-worker-snack-bar',
  templateUrl: 'update-service-worker-snack-bar.html',
  styleUrls: ['update-service-worker-snack-bar.css'],
})
export class UpdateServiceWorkerSnackBar {


  constructor(
    public snackBarRef: MatSnackBarRef<UpdateServiceWorkerSnackBar>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) {

  }


  update() {
    console.log("Test");
    this.snackBarRef.dismiss()
    document.location.reload()
  }


  /*
  constructor(private _snackBar: MatSnackBar) { }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }
  */
}





@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  handleError(error: any): void {
    //console.log("Test");
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;

    if (chunkFailedMessage.test(error.message)) {
      console.log("Reload Page");
      //window.location.reload();
    }
  }
}



/*
//HANDLE PUSH NOTIFICATIONS
@Injectable()
export class PushNotificationService {
  readonly VAPID_PUBLIC_KEY = 'YOUR_PUBLIC_VAPID_KEY_HERE'; // from your backend

  constructor(
    private swPush: SwPush,
    private swUpdate: SwUpdate
  ) {
    //this.checkForUpdates();
  }

  // 🔄 Automatically checks for service worker updates
  private checkForUpdates() {
    this.swUpdate.available.subscribe(event => {
      console.log('New version available:', event);
      if (confirm('A new version is available. Reload now?')) {
        this.swUpdate.activateUpdate().then(() => document.location.reload());
      }
    });
  }

  // 🔔 Request permission and subscribe user to push notifications
  subscribeToNotifications() {
    if (!this.swPush.isEnabled) {
      console.warn('Push notifications are not enabled or supported in this browser.');
      return;
    }

    this.swPush.requestSubscription({
      serverPublicKey: this.VAPID_PUBLIC_KEY
    })
      .then(subscription => {
        console.log('User subscribed to push notifications:', subscription);
        // 👉 Send subscription to your backend
      })
      .catch(err => {
        console.error('Failed to subscribe user:', err);
      });
  }

  // 📩 Handle incoming messages
  listenToMessages() {
    this.swPush.messages.subscribe((message) => {
      console.log('Received push message:', message);
    });
  }

  // ⚠️ Handle push errors
  listenToErrors() {
    this.swPush.notificationClicks.subscribe(({ action, notification }) => {
      console.log('Notification clicked:', notification);
    });
  }
}
*/
